import { render } from "./ViewImprint.vue?vue&type=template&id=39d798e3&scoped=true"
import script from "./ViewImprint.vue?vue&type=script&lang=ts"
export * from "./ViewImprint.vue?vue&type=script&lang=ts"

import "./ViewImprint.vue?vue&type=style&index=0&id=39d798e3&lang=less&scoped=true"
import "./ViewImprint.vue?vue&type=style&index=1&id=39d798e3&lang=less"
script.render = render
script.__scopeId = "data-v-39d798e3"

export default script